import React, {  PureComponent  } from 'react';
import { Collapse, Empty } from 'antd';
import CustomPieChart from '../_Generic/PieChart/index';
import { efosTotal } from './graphicsData';
import EmptyContent from './EmptyContent';
const { Panel } = Collapse;


class Efos extends PureComponent {

	render() {
		if(!this.props.data)
			return <EmptyContent />;
		const { data, numberOfEfos } = this.props.data;	
		return (
			<Collapse accordion defaultActiveKey={['1']}>                
                <Panel header="Información de EFOS" key="1">
                    <div className="box">
						<span className="label">Número de EFOS</span>
						<span className="number-text">{numberOfEfos}</span>
					</div>
                </Panel>
				{
					this.props.data.data && 
					<Panel header="Total de EFOS" key="2">
						{
							data ?
								<CustomPieChart data={efosTotal(data)} width={300} height={250} colorFill="#8884d8" />
							: 
								<Empty />
						}
					</Panel>
				}	
            </Collapse>
		)
	}
}

export default Efos;